import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { ApplicationRejectionType } from '../../../../domain/qualification';
import { COAST_VOICE_PHONE } from '../../../../env';
import { TerminalWizardPage } from '../../../../general/components/wizard-page';
import { RootState } from '../../../../store';

const completePageSelector = ({ applicationResult }: RootState) => ({
  reason: applicationResult.reason,
  rejectionType: applicationResult.rejectionType,
});

const titleByRejectionType: Record<ApplicationRejectionType, React.ReactNode> = {
  ineligible: <>You are not eligible for a Coast account.</>,
  invalid: (
    <>
      We are unable to approve
      <br /> your application.
    </>
  ),
  locked: (
    <>
      We can&apos;t proceed
      <br /> with your application.
    </>
  ),
  unsupported_state: (
    <>
      Coast is not available
      <br /> in your state.
    </>
  ),
  inactive_application: <>Your application has expired.</>,
};

const ApplicationDeniedPage: FC = () => {
  const { reason, rejectionType } = useSelector(completePageSelector);

  return (
    <TerminalWizardPage
      title={rejectionType && titleByRejectionType[rejectionType]}
      subtext={
        <Box component="span" sx={{ whiteSpace: 'pre-line' }}>
          {reason}
        </Box>
      }
    >
      <Typography variant="inherit" align="center" color="textSecondary">
        If you have any questions, please call us at:
        <br />
        <Typography variant="inherit" component="span" color="primary">
          {COAST_VOICE_PHONE}
        </Typography>
        . Our service hours are 8am to
        <br /> 6pm ET, Monday through Friday.
      </Typography>
    </TerminalWizardPage>
  );
};

export { ApplicationDeniedPage };
